import { QueryClient } from "@tanstack/react-query";

export const sharedQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});
